import React, { PureComponent } from "react";
import PropTypes from "prop-types";
import classNames from "classnames";

export default class Copyright extends PureComponent {
  static propTypes = {
    className: PropTypes.any,
  };

  render() {
    const year = new Date().getFullYear();

    const className = classNames("copyright", this.props.className);

    const copyright = `\u00A9 ${year} Hatch, Inc.`;

    return (
      <small data-testid="copyright" className={className}>
        {copyright}
      </small>
    );
  }
}
